import { render, staticRenderFns } from "./SolicitorCaseDetails.vue?vue&type=template&id=6625a64d"
import script from "./SolicitorCaseDetails.vue?vue&type=script&lang=js"
export * from "./SolicitorCaseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports